import styled from 'styled-components';
import { customMedia } from 'styles/utils';

export const LargePanelSectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  padding: ${props =>
    props.first && props.hasBanner
      ? '1rem 3rem 0rem 3rem'
      : props.first
      ? ' 2rem 3rem 0rem 3rem'
      : ' 2rem 3rem'};
`;

export const CollapseWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;

  > button {
    text-decoration: underline;
    font-weight: ${props => props.theme.font.weight.regular};
    svg {
      path {
        stroke: none;
      }
    }
  }
  button:hover {
    text-decoration: none;
  }
`;

export const IllustrationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 2rem;

  > img {
    width: 160px;
  }

  ${customMedia.lessThan('medium')`
    display: none;
  `};
`;
